import { DragStartEvent, DragEndEvent } from "@dnd-kit/core"
import { closestCenter, DndContext, DragOverlay, } from '@dnd-kit/core';
import { SortableContext, arrayMove, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { List } from "@mui/material";
import MyListItem from "./MyListItem";
import MySortableListItem from "./MySortableListItem";
import { useDefaultSensors } from './presets';
import { iKanbanItem } from './types';
import { useState } from "react";

interface SortableProps {
  items: Array<iKanbanItem>,
}

export default function({ items: pItems }: SortableProps) {
  const sensors = useDefaultSensors();
  const [activeItem, setActiveItem] = useState<iKanbanItem | null>(null);
  const [items, setItems] = useState(pItems);

  const handleDragStart = (event: DragStartEvent) => {
    const { active } = event;
    const activeItem = items.find(item => item.id === active.id);
    if (activeItem) {
      setActiveItem(activeItem);
    }
  }

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item => item.id === over.id);

        return arrayMove(items, oldIndex, newIndex);
      });
    }

    setActiveItem(null);
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <List>
        <SortableContext
          items={items}
          strategy={verticalListSortingStrategy}
        >
          {items.map(item => <MySortableListItem key={item.id} item={item} />)}
        </SortableContext>
        <DragOverlay>
          {activeItem ? <MyListItem item={activeItem} /> : null}
        </DragOverlay>
      </List>
    </DndContext>
  )
}
